export const status = (row) => {
    if (row.status === "InfoReceived") {
      return "Processing";
    }
    if (
      row.status === "PickedUp" ||
      row.status === "Departure" ||
      row.status === "Arrival" || row.status === "InTransit"
    ) {
      return "Shipped";
    }
    if (
      row.status === "AvailableForPickup" ||
      row.status === "OutForDelivery" ||
      row.status === "Returned" ||
      row.status === "Returning" || !row.status || row.status === "Exception"
    ) {
      return "Warning";
    }
    if (row.status === "Delivered") {
      return "Delivered";
    }
  };